import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router";
import { initMsal, getAccount } from "./auth/msal";
import { api } from "./api/client";
import { authStore } from "./auth/authStore";
import "./styles/tokens.css";

async function bootstrap() {
  await initMsal();

  // Preload /me so route guards can decide on /unauthorized synchronously.
  if (getAccount()) {
    try {
      const me = await api.me();
      authStore.setMe(me);
    } catch {
      // Swallow; route guard handles it. Don't block app bootstrap.
    }
  }

  const app = createApp(App);
  app.use(router);
  app.mount("#app");
}

void bootstrap();
